var map = {
	"./404.svg": 94235,
	"./admin.svg": 76190,
	"./bell-fill.svg": 6000,
	"./bug.svg": 92813,
	"./camera.svg": 90228,
	"./chart.svg": 13751,
	"./clipboard.svg": 96889,
	"./comment.svg": 83348,
	"./component.svg": 10250,
	"./create-user.svg": 92007,
	"./dashboard.svg": 4679,
	"./device.svg": 14291,
	"./documentation.svg": 23397,
	"./dollar.svg": 46887,
	"./drag.svg": 28715,
	"./edit.svg": 95869,
	"./education.svg": 3937,
	"./email.svg": 39083,
	"./evn_npt.svg": 20137,
	"./example.svg": 21649,
	"./excel.svg": 42474,
	"./exit-fullscreen.svg": 54861,
	"./eye-open.svg": 12429,
	"./eye.svg": 95628,
	"./form.svg": 3771,
	"./fullscreen.svg": 6638,
	"./guide 2.svg": 5961,
	"./guide.svg": 47987,
	"./icon.svg": 92814,
	"./international.svg": 5091,
	"./language.svg": 5247,
	"./layout.svg": 49427,
	"./like.svg": 71776,
	"./link.svg": 81445,
	"./list.svg": 99161,
	"./lock.svg": 52636,
	"./message.svg": 38166,
	"./money.svg": 49659,
	"./nested.svg": 85016,
	"./password.svg": 39902,
	"./pdf.svg": 38001,
	"./people.svg": 34952,
	"./peoples.svg": 46779,
	"./qq.svg": 75951,
	"./role.svg": 73637,
	"./scissors.svg": 11984,
	"./search.svg": 58217,
	"./shopping.svg": 65697,
	"./size.svg": 88334,
	"./skill.svg": 92160,
	"./star.svg": 48637,
	"./station.svg": 12131,
	"./tab.svg": 94598,
	"./table.svg": 54383,
	"./theme.svg": 88972,
	"./tree-table.svg": 41622,
	"./tree.svg": 92701,
	"./user.svg": 68848,
	"./wechat.svg": 80719,
	"./zip.svg": 71902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;